import React from 'react'
import PropTypes from 'prop-types'

import app from 'common/builder/components/chart/FlowChart/app'

/**
 * This component is used to expose coodrinates of the component to the app.js,
 * so we could retrieve coordinates of the component by id.
 */
export default class CachedView extends React.PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.id === prevProps.id) {
      return
    }

    this.uncacheNode(this.element, prevProps.id)
    this.cacheNode(this.element)
  }

  cacheNode = (element) => {
    app.setNode(element)
    app.render()
  }

  uncacheNode = (element, id) => {
    app.deleteNode(element, id)
    app.render()
  }

  handleRef = (element) => {
    if (element) {
      this.cacheNode(element)
    } else {
      if (this.element) {
        this.uncacheNode(this.element)
      }
    }
    this.element = element
  }

  render() {
    return <view ref={this.handleRef} {...this.props} />
  }
}
